import { GET_SIIM } from './../constants';
import { handleActions } from "redux-actions"

export const siim  = handleActions(
  {
    [ GET_SIIM ]: (state, action) => {
        const { error, data } = action.payload
        if (error) {
            return []
        } else {
            return data
        }
    }
  }, []
)